<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Staff Members",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Staff Members",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Staff Members",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Full Name",
          sortable: true,
        },
        {
          key: "position.name",
          label: "Position",
          sortable: true,
        },
        {
          key: "phone1",
          label: "Phone 1",
          sortable: true,
        },
        {
          key: "phone2",
          label: "Phone 2",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
        },
        // {
        //   key: "user.name",
        //   label: "Added By",
        //   sortable: true,
        // },
        // {
        //   key: "addedon",
        //   label: "Added",
        //   sortable: true,
        // },
        {
          sortable: false,
          key: "load",
          label: "LOAD",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        email: "",
        gender: "",
        phone1: "",
        phone2: "",
        address: "",
        dob: "",
        dop: "",
        NIN: "",
        marital: "",
        education: "",
        // salary: "",
        position: "",
        initials: "",
      },
      editeData: {
        name: "",
        email: "",
        gender: "",
        phone1: "",
        phone2: "",
        address: "",
        dob: "",
        dop: "",
        NIN: "",
        marital: "",
        education: "",
        // salary: "",
        position: "",
        initials: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      edit: {
        name: "",
        id: "",
      },
      existingStaff: [],
      nameError: "",
      phoneError: "",
      genderError: "",
      modal: "",
      maritals: [
        {
          id: 1,
          name: "Single",
        },
        {
          id: 2,
          name: "Married",
        },
        {
          id: 3,
          name: "Widowed",
        },
        {
          id: 4,
          name: "Divorced",
        },
      ],
      gend: [{ name: "Male" }, { name: "Female" }],
      education: [
        { name: "O'Level" },
        { name: "A'Level" },
        { name: "Diploma" },
        { name: "Certificate" },
        { name: "Bachelor Degree" },
        { name: "Masters Degree" },
        { name: "PHD" },
      ],
    };
  },
  computed: {
    ...mapGetters("staff", ["AllStaff", "AllPositions", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllStaff ? this.AllStaff.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllStaff ? this.AllStaff.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStaff: "staff/fetchStaff",
      FetchPositions: "staff/fetchPositions",
      AddStaff: "staff/addStaff",
      EditStaff: "staff/editStaff",
      DeleteStaff: "staff/deleteStaff",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllStaff ? this.AllStaff.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
    },

    resetAddModal() {
      (this.data = {
        name: "",
        email: "",
        gender: "",
        phone1: "",
        phone2: "",
        address: "",
        dob: "",
        dop: "",
        NIN: "",
        marital: "",
        education: "",
        position: "",
        initials: "",
      }),
        this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingStaff = this.AllStaff.filter((staff) => {
          return staff.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingStaff.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingStaff = [];
      }
    },
    addStaff(modal) {
      if (this.data.name == "") {
        this.nameError = "Staff Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.position == "") {
        this.positionError = "Position Field is required";
        return;
      } else {
        this.positionError = "";
      }
      if (this.data.phone1 == "") {
        this.phoneError = "Phone Number Field is required";
        return;
      } else {
        this.phoneError = "";
      }
      if (this.data.gender == "") {
        this.genderError = "Gender Field is required";
        return;
      } else {
        this.genderError = "";
      }
      this.modal = modal;
      this.AddStaff(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.edit.id = values.item.id;
      this.edit.name = values.item.name;
      this.edit.email = values.item.email;
      this.edit.gender = values.item.gender;
      this.edit.phone1 = values.item.phone1;
      this.edit.phone2 = values.item.phone2;
      this.edit.address = values.item.address;
      this.edit.dob = values.item.dob;
      this.edit.dop = values.item.doApp;
      this.edit.NIN = values.item.nin_no;
      this.edit.marital = values.item.marital_status;
      this.edit.education = values.item.education;
      this.edit.position = values.item.position;
      this.edit.initials = values.item.initials;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteStaff(modal) {
      this.modal = modal;
      this.DeleteStaff(this.deletedata);
      this.closeModal(modal);
    },
    editStaff(modal) {
      if (this.edit.name == "") {
        this.nameError = "Staff Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.EditStaff(this.edit);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchStaff();
    this.FetchPositions();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_staff_member')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of Staff Members</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-staff-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_staff_member')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllStaff ? AllStaff : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(load)="data">
                  <router-link
                    :to="{ name: 'StaffLoad', params: { staff: data.item.id } }"
                    class="btn btn-primary btn-sm"
                    title="Manage Load"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('view_staff_load')
                      )
                    "
                    ><i class="fa fa-bars"></i> Load
                  </router-link>
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-staff-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_staff_member')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-staff-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_staff_member')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-staff-modal"
        size="lg"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_staff_member')
          )
        "
      >
        <template #modal-title> Add New Staff Member </template>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Staff Name <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Staff Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <small>{{ nameError }}</small>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Position <span class="text-danger">*</span></label>
                <div class="input-group">
                  <model-list-select
                    :list="AllPositions ? AllPositions : []"
                    v-model="data.position"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Position"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="positionError">
                  <small>{{ positionError }}</small>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Phone Number 1 <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="number"
                    placeholder="Phone Number 1"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.phone1"
                  />
                </div>
                <div class="text-danger" v-if="phoneError">
                  <small>{{ phoneError }}</small>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Phone Number 2 <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="number"
                    placeholder="Phone Number 2"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.phone2"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Address <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Address"
                    class="form-control"
                    v-model="data.address"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>NIN Number <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="NIN Number"
                    class="form-control"
                    v-model="data.NIN"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group mb-3">
                <label
                  >Email <small class="text-primary">(Optional)</small></label
                >
                <div class="input-group">
                  <input
                    type="email"
                    placeholder="Email Address"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.email"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Gender <span class="text-danger">*</span></label>
                <div class="input-group">
                  <model-list-select
                    :list="gend ? gend : []"
                    v-model="data.gender"
                    option-value="name"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Gender"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="genderError">
                  <small>{{ genderError }}</small>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Date Of Birth <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.dob"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label
                  >Date Of Appointment <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.dop"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label
                  >Highest Level of Education
                  <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <model-list-select
                    :list="education ? education : []"
                    v-model="data.education"
                    option-value="name"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Level of Education"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Marital Status <span class="text-danger">*</span></label>
                <div class="input-group">
                  <model-list-select
                    :list="maritals ? maritals : []"
                    v-model="data.marital"
                    option-value="name"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Marital Status"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Initials <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.initials"
                    placeholder="Initial e.g KB"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('add-staff-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm disabled btn-outline-primary"
          >
            <b-spinner variant="primary" small label="Saving"></b-spinner>
            Submitting Staff...
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addStaff('add-staff-modal')"
          >
            <i class="fa fa-check"></i>
            Submit New Staff
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-staff-modal"
        hide-footer
        size="lg"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_staff_member')
          )
        "
      >
        <template #modal-title> Edit Staff Member {{ edit.name }}</template>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Staff Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @input="resetError"
                    v-model="edit.name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <small>{{ nameError }}</small>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Position <span class="text-danger">*</span></label>
                <div class="input-group">
                  <model-list-select
                    :list="AllPositions ? AllPositions : []"
                    v-model="edit.position"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Position"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="positionError">
                  <small>{{ positionError }}</small>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Phone Number 1 <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="number"
                    placeholder="Phone Number 1"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="edit.phone1"
                  />
                </div>
                <div class="text-danger" v-if="phoneError">
                  <small>{{ phoneError }}</small>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Phone Number 2 <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="number"
                    placeholder="Phone Number 2"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="edit.phone2"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Address <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Address"
                    class="form-control"
                    v-model="edit.address"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>NIN Number <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="NIN Number"
                    class="form-control"
                    v-model="edit.NIN"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group mb-3">
                <label
                  >Email <small class="text-primary">(Optional)</small></label
                >
                <div class="input-group">
                  <input
                    type="email"
                    placeholder="Email Address"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="edit.email"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Gender <span class="text-danger">*</span></label>
                <div class="input-group">
                  <model-list-select
                    :list="gend ? gend : []"
                    v-model="edit.gender"
                    option-value="name"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Gender"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
                <div class="text-danger" v-if="genderError">
                  <small>{{ genderError }}</small>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group mb-3">
                <label>Date Of Birth <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="edit.dob"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label
                  >Date Of Appointment <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="edit.dop"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label
                  >Highest Level of Education
                  <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <model-list-select
                    :list="education ? education : []"
                    v-model="edit.education"
                    option-value="name"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Level of Education"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Marital Status <span class="text-danger">*</span></label>
                <div class="input-group">
                  <model-list-select
                    :list="maritals ? maritals : []"
                    v-model="edit.marital"
                    option-value="name"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Marital Status"
                    @input="resetError()"
                  >
                  </model-list-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Initials <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="edit.initials"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('edit-staff-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm disabled btn-outline-success"
          >
            <b-spinner variant="success" small label="Saving"></b-spinner>
            Saving changing...
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-outline-success"
            @click="editStaff('edit-staff-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete staff starts -->
      <b-modal
        id="delete-staff-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_member')
          )
        "
      >
        <template #modal-title>
          <h5 class="text-danger">
            Delete Staff member <strong>{{ deletedata.name }}</strong>
          </h5></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h6 class="px-4">
              Do you want to delete staff member
              <strong>{{ deletedata.name }}</strong> ? Click Proceed Button to
              delete.
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-staff-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm disabled btn-outline-danger"
          >
            <b-spinner variant="danger" small label="Deleting"></b-spinner>
            Deleting...
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteStaff('delete-staff-modal')"
          >
            <i class="fa fa-trash"></i> Proceed
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
